// @noflow
import Cookies from "js-cookie"
import "common/services/intl/momentInit"
import queryString from "query-string"

import session from "./session"
import { PREFERRED_CURRENCY_EXPIRATION_DAYS } from "common/consts/cookies"
import cuckoo from "common/services/cuckoo/cuckoo"
import { getLanguageInfo } from "common/services/staticData"

require("moment-duration-format")

const langInfo = getLanguageInfo(window.__INITIAL_STATE__)

// eslint-disable-next-line no-undef
moment.locale(langInfo.moment)

window.Skypicker = {
  version: "@@version", // Replaced by webpack
  timestamp: "@@timestamp", // Replaced by webpack
  config: {
    dateFormat: langInfo.dateFormat,
    timeFormat: langInfo.timeFormat,
    durationFormat: langInfo.durationFormat,
    direction: document.documentElement.getAttribute("dir"),
  },
  helpers: {
    /**
     * atime: 1356346200   Mon, 24 Dec 2012 10:50:00 GMT
     * dtime: 1356340200   Mon, 24 Dec 2012 09:10:00 GMT
     *
     * diff = 6000 (in seconds)
     * 6000s / 3600 = 1.66666 hour
     *
     * 6000 - 3600 = 2400s rest
     * 2400 / 60 = 40 minutes
     */
    computeDurationBetweenDates(date1, date2) {
      let duration

      const diff = Math.abs(date1 - date2) // difference in seconds

      const hours = Math.floor(diff / 3600) // number of "full hours" in the difference
      const minutes = (diff - hours * 3600) / 60 // number of minutes in the last (not full) hour

      duration = `${hours}h`
      if (minutes > 0) {
        duration += `\xA0${minutes}m` // non-breakable space is char 0xa0 (160 dec)
      }

      return duration
    },

    prepareEmptyTrip() {
      return {
        compute: {
          durationInSeconds: 0,
          durationInHours: 0,
          durationInHoursRemainingMinutes: 0,
        },
        departure: null,
        arrival: null,
        duration: null,
        stops: 0,
        flights: [],
      }
    },
  },
}

const isDev = window.SP_GLOBALS.SKYPICKER_ENV !== "production"
// Cookie settings
// ---------------
window.Skypicker.cookieOptions = {
  // Probably due to IE bug, which cause sending cookies to subdomains
  // consider setting it in IE only
  // old comment: cookie will be available to the entire domain
  domain: isDev ? null : window.location.host,
}
if (!(isDev || window.SP_GLOBALS.IS_STAGING)) {
  const canUseSecure = window.location.protocol === "https:"
  Cookies.defaults.secure = canUseSecure
  window.Skypicker.cookieOptions.secure = canUseSecure
}

// Currency
// --------
Cookies.set("preferred_currency", window.SP_GLOBALS.SKYPICKER_CURRENCY, {
  ...Skypicker.cookieOptions,
  expires: PREFERRED_CURRENCY_EXPIRATION_DAYS,
})

// Iframe - set from path to cookies
// Clicktripz iframe identified by utm_source=clicktripz
const queryObject = queryString.parse(window.location.search)
const iframe = queryObject.iframe || queryObject.utm_source

if (iframe) {
  Cookies.set("frame_ancestor_url", iframe, Skypicker.cookieOptions)
}

// Shim: Google maps
// ===
/**
 * get bounds for polygon - this function existed in api v2 but it's missing in v3
 */
if (window.google && window.google.maps && !window.google.maps.Polygon.prototype.getBounds) {
  window.google.maps.Polygon.prototype.getBounds = function() {
    const bounds = new google.maps.LatLngBounds()
    const paths = this.getPaths()
    let path
    for (let p = 0; p < paths.getLength(); p++) {
      path = paths.getAt(p)
      for (let i = 0; i < path.getLength(); i++) {
        bounds.extend(path.getAt(i))
      }
    }
    return bounds
  }
}

// Config: Cuckoo
// ==============
cuckoo.identify(session.userId)

document.body.className += ` ${window.SP_GLOBALS.SKYPICKER_LNG}`

// EXPOSE
// ======
export default Skypicker.config
